var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccessControlActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Access_Control_Active",
    "data-name": "Access Control_Active",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 23.001,
    viewBox: "0 0 24 23.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_142888",
    "data-name": "Path 142888",
    d: "M327.25,260H327v-1.5a2.5,2.5,0,1,0-5,0V260h-.249a1.752,1.752,0,0,0-1.75,1.75v3.5a1.752,1.752,0,0,0,1.75,1.75h5.5a1.752,1.752,0,0,0,1.75-1.75v-3.5A1.752,1.752,0,0,0,327.25,260Zm-3.757-1.5a1,1,0,0,1,2,0V260H323.5Zm0,0",
    transform: "translate(-305 -244)",
    fill: "#262626"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_142889",
    "data-name": "Path 142889",
    d: "M13.5,261.751a3.255,3.255,0,0,1,2-3V258.5a3.955,3.955,0,0,1,.4-1.695A4.727,4.727,0,0,0,13.25,256h-8.5A4.746,4.746,0,0,0,0,260.746v3.5a.75.75,0,0,0,.75.75H13.5Zm0,0",
    transform: "translate(0 -244)",
    fill: "#262626"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_142890",
    "data-name": "Path 142890",
    d: "M95.332,5a5,5,0,1,1-5-5,5,5,0,0,1,5,5Zm0,0",
    transform: "translate(-81.332)",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessControlActive);
export default __webpack_public_path__ + "static/media/access_control_active.9c0812e0.svg";
export { ForwardRef as ReactComponent };